/**
 * sun-product-siblings.js — Web Component <sun-product-siblings>
 *
 * Navigates to the sibling product URL when a radio input changes.
 *
 * Scope: rendered inside sections/sun-product.liquid via
 * snippets/sun-product-siblings.liquid. Loaded from sun-product.liquid.
 */
if (!customElements.get('sun-product-siblings')) {
  customElements.define('sun-product-siblings', class extends HTMLElement {
    connectedCallback() {
      this.onSiblingChange = this.onSiblingChange.bind(this);
      this.addEventListener('change', this.onSiblingChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onSiblingChange);
    }

    onSiblingChange(e) {
      const input = e.target;
      if (!input.matches('input[data-sibling-url]')) return;
      const url = input.getAttribute('data-sibling-url');
      if (url) window.location.href = url;
    }
  });
}
